import { ErrorContext, ErrorLogger } from '@mam/main/ErrorLogger/ErrorLogger';

export class ConsoleErrorLogger implements ErrorLogger {
	public logError<Error, MetaValue>(error: Error, context: ErrorContext<MetaValue> | null = null) {
		console.error(error);
		// eslint-disable-next-line no-console
		console.log(context);
	}
}
